import { usePrivy } from "@privy-io/react-auth";
import { Button } from "components/Button";
import { useUserStore } from "stores/user";
import { EUserRole } from "types/user";

export const AuthButton = () => {
  const { login, user, logout } = usePrivy();
  const { userData } = useUserStore();

  const isLoggedIn = !!user && !!userData;
  const isAuthorized = isLoggedIn && userData?.role === EUserRole.ADMIN;

  const handleClick = () => {
    if (isLoggedIn && !isAuthorized) {
      logout();
      return;
    }
    
    login();
  };

  return (
    <Button onClick={handleClick}>
      {!isLoggedIn && !isAuthorized ? "Authorize" : "Logout"}
    </Button>
  );
};
